import { IObjektVy } from '../../../../../Types/ObjektVy';
import associeradListVy from '../../../_Common/Components/BusinessCollectionComponents/associeradListVy';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';
import { standardVy } from '../../../../../Utils/ObjektVyUtils';
const bakgrundsjobb = ObjektVySida('standard', [
  [
    objektVyGrupp(
      'info',
      [
        'RUBRIK',
        'STATUS',
        'STATUS_TEXT',
        'START_TID',
        'SLUT_TID',
        'PROGRESS',
        'TidKlar',
      ],
      ' '
    ),
    objektVyGrupp(
      'logs',
      [
        associeradListVy('Logg', {
          inCard: true,
          defaultVisningstyp: 'tabell',
          detailsFullPage: true,
          noCaption: false,
        }),
      ],
      ' '
    ),
  ],
]);

const standard: IObjektVy = standardVy([bakgrundsjobb]);

export const BakgrundsjobbVyer: IObjektVy[] = [standard];
